import type { ICustomerQuery, IOrdersEdges } from "@repo/shopify/src/queries/customer-gql";

export interface IUserState extends ICustomerQuery {
  accessToken: string;
  isEntryAllowed?: boolean;
}

export const initialStateUser: IUserState = {
  accessToken: "",
  customer: {
    acceptsMarketing: false,
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    phone: "",
    tags: [],
    metafields: [],
    addresses: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
    },
    numberOfOrders: "",
    createdAt: "",
    displayName: "",
    orders: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
      totalCount: "",
    },
    gender: undefined,
    birth: undefined,
    wishlist: undefined,
    updatedAt: "",
  },
  isEntryAllowed: false,
};

// user store의 login action
const USER_LOGIN = "USER/LOGIN" as const;
const USER_LOGOUT = "USER/LOGOUT" as const;
const USER_UPDATE_INFO = "USER/UPDATE_INFO" as const;
const USER_UPDATE_ORDERS = "USER/UPDATE_ORDERS" as const;
const USER_ENTRY_ALLOWED = "USER/USER_ENTRY_ALLOWED" as const;

export const user = (state = initialStateUser, action: TUserAction) => {
  switch (action.type) {
    case USER_LOGIN:
      return { ...state, accessToken: action.user.accessToken };
    case USER_LOGOUT:
      return { ...initialStateUser };
    case USER_UPDATE_INFO:
      return { ...state, ...action.user };
    case USER_UPDATE_ORDERS:
      return { ...state, orders: action.orders };
    case USER_ENTRY_ALLOWED:
      return { ...state, isEntryAllowed: action.isEntryAllowed };
    default:
      return state;
  }
};

// 액션 타입 정의
type TUserAction =
  | ReturnType<typeof userLogin>
  | ReturnType<typeof userLogout>
  | ReturnType<typeof updateUser>
  | ReturnType<typeof updateOrders>
  | ReturnType<typeof updateAllowance>;

const userLogin = (_user: IUserState) => ({ type: USER_LOGIN, user: _user });
const userLogout = () => ({ type: USER_LOGOUT });
const updateUser = (_user: IUserState) => ({ type: USER_UPDATE_INFO, user: _user });
const updateOrders = (orders: IOrdersEdges) => ({ type: USER_UPDATE_ORDERS, orders });
const updateAllowance = (isEntryAllowed: boolean) => ({ type: USER_ENTRY_ALLOWED, isEntryAllowed });

export const userCreator = {
  userLogin,
  userLogout,
  updateUser,
  updateOrders,
  updateAllowance,
};
